import ky from "ky";

export const fetchTopSearchedProducts = async () => {
  try {
    const response = await ky.get(`/wapi/v1/top-searched-products?fields=id,name,urlName,imageNameShort,supScore,bioScore,qualityScore,scoreProperties`, {
      headers: {
        'X-Api-Key': '9j-C@Mt3XU_@3bZWkJN6ypwVsXqjhEqx-Q.Fq8Twkq8T46PhD.b2DEaiqDz_.7uF'
      }
    });

    return await response.json();
  } catch (error) {
    console.error("Error fetching top searched products:", error);
    throw error;
  }
}

export const fetchBestSupScoreProducts = async () => {
  try {
    const response = await ky.get(`/wapi/v1/best-sup-score-products?fields=id,name,urlName,imageNameShort,supScore,bioScore,qualityScore,scoreProperties`, {
      headers: {
        'X-Api-Key': '9j-C@Mt3XU_@3bZWkJN6ypwVsXqjhEqx-Q.Fq8Twkq8T46PhD.b2DEaiqDz_.7uF'
      }
    });

    return await response.json();
  } catch (error) {
    console.error("Error fetching best sup-score products:", error);
    throw error;
  }
}
